import {adaptive} from 'styles/mixins/Adaptive';
import {IMainInfoDataValues} from 'modules/product-card/types';

export const ADVICE_LIST_PRODUCT_CARD = 'productCard';

export const INTERIOR_LABEL: string = 'visual-';

export const MAX_IMAGES_NUMBER: number = 4;

export const VISUAL_MAIN_CARD_IMAGE_MAP = [
    {
        imageSize: {
            height: 640,
            width: 1280,
        },
        screenWidth: adaptive.SIZE_LG_MIN,
    },
    {
        imageSize: {
            height: 720,
            width: 1440,
        },
        screenWidth: adaptive.SIZE_XL_MIN,
    },
    {
        defaultSize: true,

        imageSize: {
            height: 740,
            width: 1920,
        },
        screenWidth: adaptive.SIZE_FULL_HD,
    },
];

export const PRODUCT_CARD_HEADER_MODE = {
    galleryModal: 'galleryModal',
    productPage: 'productPage',
    storeMap: 'storeMap',
} as const;

// TODO: Вернуться, если пересмотрим использование таких конструкций на проекте (калькуляторы, карточка, модалки)
// Необходимо исключение, чтобы ключи были в текущем порядке
/* eslint-disable sort-keys */
export const MAIN_INFO_DATA: Record<
    'ADVICES' | 'DESCRIPTION' | 'FILES' | 'PROPERTIES' | 'SIMILAR_PRODUCTS',
    IMainInfoDataValues
> = {
    SIMILAR_PRODUCTS: {
        label: 'Аналоги',
        name: 'similar-products',
    },
    DESCRIPTION: {
        label: 'Описание',
        name: 'description',
    },
    PROPERTIES: {
        label: 'Характеристики',
        name: 'properties',
    },
    FILES: {
        label: 'Инструкции и документы',
        name: 'files',
    },
    ADVICES: {
        label: 'Советы',
        name: 'advices',
    },
};
/* eslint-enable sort-keys */

export const NAV_USED_IN = {
    header: 'header',
    main: 'main',
} as const;

export const NAV_TABS_MIN_NUMBER = 2;
export const HEADER_HEIGHT_ADAPTIVE = -56;
export const HEADER_HEIGHT_DESKTOP = -150;

export const SPECIFICATIONS_SCROLL_NAME = 'specifications';

export const REVIEWS_CODE = 'REVIEWS';
export const VIVINO_CODE = 'VIVINO';

export const SECTION_CODE = {
    VINO: 'vino',
    IGRISTOE_VINO: 'igristoe-vino',
    VISKY: 'viski',
    KONYAK: 'konyak',
    VODKA: 'vodka',
    AKSESSUARY: 'aksessuary',
    FINE_AND_RARE: 'fineandrare',
    KSN: 'ksn',
    MINERALNAYA_VODA: 'mineralnaya_voda',
    SAKE: 'sake',
    SHAMPANSKOE: 'shampanskoe',
    STEKLO: 'steklo',
    VODA: 'voda',
    SOK: 'soki',
    VODA_I_SOKI: 'voda_i_soki',
    CHAMPAGNE: 'shampanskoe_i_igristoe_vino',
    ARMANYAK: 'armanyak',
    AKVAVIT: 'akvavit',
    GRAPPA: 'grappa',
    KALVADOS: 'kalvados',
    BOKALY: 'bokaly',
};

const {
    AKSESSUARY,
    FINE_AND_RARE,
    IGRISTOE_VINO,
    KONYAK,
    KSN,
    MINERALNAYA_VODA,
    SAKE,
    STEKLO,
    VINO,
    VISKY,
    VODA_I_SOKI,
} = SECTION_CODE;

export const PRODUCT_CATEGORIES_CODES_SORTED = [
    FINE_AND_RARE,
    SAKE,
    VISKY,
    KONYAK,
    KSN,
    IGRISTOE_VINO,
    VINO,
    MINERALNAYA_VODA,
    VODA_I_SOKI,
    STEKLO,
    AKSESSUARY,
];

export const PRODUCT_SHARE_BUTTON_LABEL = 'Копировать прямую ссылку';

// eslint-disable-next-line no-shadow
export enum ProductStickyHeaderPageName {
    Product = 'product',
    Review = 'review',
}

export const REDIRECT_SOURCE_STORAGE_KEY = 'PDP_REDIRECT_SOURCE';
export const REDIRECT_INFORMER_TEXT = 'нет в наличии. Перенаправили вас на другой винтаж';
